//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uploadUnit from '../components/uploadUnit.vue'
import utils from '../utils/index'
import CONSTANTS from '../constants/index'
import SNKH5Uploader from 'snk-image-js/lib/h5/uploader'
const cloudImageBaseURL = process.env.VUE_APP_CLOUDIMAGE_API_URL
export default {
  name: 'UploadImage',
  data() {
    return {
      historyImgObj: null,
      checkCode: '',
      insureIndex: 2, // 投保资料的索引, 从2开始, 0, 1 分配给行车证
      fileTypeList: {
        imgIDCardVo: 'S001_00103',
        imgInsureVo: 'S001_00102',
        imgValidateVo: 'S001_00101',
      },
      imageData: {
        imgIDCardVo: {
          // 身份证
          imgPathList: [],
        },
        imgCustomed: {
          // 自定义的: 驾驶证
          imgPathList: [],
        },
        imgBusinessLicense: {
          // 营业执照
          imgPathList: [],
        },
        imgInsureVo: {
          // 投保资料
          fileTypeList: [''],
          imgPathList: [],
        },
        imgValidateVo: {
          // 验车
          imgPathList: ['', '', '', '', '', ''], 
        },
      },
      // 验车照片影响目录code
      checkImgCodeMap: {
        'S001_0705_LF45': 0, // 左前45度
        'S001_0705_RF45': 1, // 右前45度
        'S001_0705_LB45': 2, // 左后45度
        'S001_0705_RB45': 3, // 右后45度
        'S001_0705_VIND': 4, // 车架号
        'S001_0705_OTH': 5   // 仪表盘1
      },
      // 影像SDK实例
      uploaderInstance: {},
      // 影像token
      uploadToken: '',
      // 是否更新过状态
      isUpdateStatus: false,
      imgTips: utils.deepClone(CONSTANTS.IMG_TIPS),
      quoteInfo: {
        base: {
          companyCode: '',
          salesmanCode: '',
        },
        riskList: [],
        owner: {
          name: '',
          identifyNumber: '',
          identifyType: '',
        },
        applicant: {
          name: '',
          identifyNumber: '',
          identifyType: '',
        },
        vehicle: {
          licenseNo: '',
          frameNo: '',
        },
      },
    }
  },
  components: { uploadUnit },
  computed: {
    isGroup() {
      // 团体
      return this.quoteInfo.owner.insuredTypeCode && this.quoteInfo.owner.insuredTypeCode !== '1'
    },
    idCardCode() {
      /**
       * 身份证目录
       * S001_0301 投保人身份证
       * S001_0601 车主身份证
      */
      return this.isGroup ? 'S001_0301' : 'S001_0601'
    },
  },
  methods: {
    // 设置影像上传状态
    setImageUpdateStatus() {
      const imageIds = this.quoteInfo.riskList.map((item) => item.imageId)
      const quotationNos = this.quoteInfo.riskList.map(
        (item) => item.quotationNo
      )
      const data = {
        imageIds,
        quotationNos,
        proposalNo: '',
        status: '10',
      }
      $http
        .updateImgStatus({
          data,
        })
        .then((res) => {
          if (res.resultCode === '0') {
            this.isUpdateStatus = true
          } else {
            Toast(res.errorMsg || '系统异常')
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    showTips(index) {
      let tips = this.imgTips[index]
      this.$vux.confirm.show({
        title: '提示',
        content: tips,
        showCancelButton: false,
      })
    },
    change(index, type) {
      if (
        index == this.imageData.imgInsureVo.fileTypeList.length - 1 &&
        this.imageData.imgInsureVo.fileTypeList.length <= 3
      ) {
        this.imageData.imgInsureVo.fileTypeList.length++
      }
    },
    handleSubmit() {
      // isUpdateStatus为false，说明一张影像都没上传
      if (!this.isUpdateStatus) {
        Toast('请至少上传一张照片!')
        return
      }
      // 给用户展示加载loading
      this.$vux.loading.show()
      setTimeout(() => {
        this.$vux.loading.hide()
        this.$router.push({ name: 'UpSuccess' })
      }, 1000)
    },
    submit() {
      let vm = this
      let totalLength = 0
      let imageData = {
        imgIDCardVo: {
          // 身份证
          fileTypeList: [],
          imgPathList: [],
        },
        imgInsureVo: {
          // 投保资料
          fileTypeList: [],
          imgPathList: [],
        },
        imgValidateVo: {
          // 验车
          fileTypeList: [],
          imgPathList: [],
        },
        paramVo: {
          flwCode: '',
          mainDocument: '',
          modelCode: 'S001_001',
          operCode: '',
          orgCode: '',
        },
        orderNo: this.$route.query.orderNo,
      }
      // 组装数据
      // 身份证
      vm.imageData.imgIDCardVo.imgPathList.forEach((item, index) => {
        if (item) {
          let length = imageData.imgIDCardVo.imgPathList.length
          imageData.imgIDCardVo.imgPathList[length] = item
          imageData.imgIDCardVo.fileTypeList[length] = 'S001_00103'
          totalLength++
        }
      })
      // 验车
      vm.imageData.imgValidateVo.imgPathList.forEach((item, index) => {
        if (item) {
          let length = imageData.imgValidateVo.imgPathList.length
          imageData.imgValidateVo.imgPathList[length] = item
          imageData.imgValidateVo.fileTypeList[length] = 'S001_00101'
          totalLength++
        }
      })
      // 投保资料
      vm.imageData.imgCustomed.imgPathList.forEach((item, index) => {
        if (item) {
          let length = imageData.imgInsureVo.imgPathList.length
          imageData.imgInsureVo.imgPathList[length] = item
          imageData.imgInsureVo.fileTypeList[length] = 'S001_00102'
          totalLength++
        }
      })
      vm.imageData.imgInsureVo.imgPathList.forEach((item, index) => {
        if (item) {
          let length = imageData.imgInsureVo.imgPathList.length
          imageData.imgInsureVo.imgPathList[length] = item
          imageData.imgInsureVo.fileTypeList[length] = 'S001_00102'
          totalLength++
        }
      })
      if (totalLength <= 0) {
        Toast('请至少上传一张照片!')
        return
      }
      $http
        .imgUploadServer({
          data: imageData,
        })
        .then((res) => {
          if (res.resultCode == '0') {
            this.$router.push({ name: 'UpSuccess' })
          } else {
            return Promise.reject(res.errorMsg)
          }
        })
        .catch((err) => {
          Toast(err || '系统异常')
        })
    },
    // 获取影像token
    getTokenToImageUpload() {
      // 影像id
      const imageIds = this.quoteInfo.riskList.map((item) => item.imageId)
      // 上传目录
      const types = ['owner', 'vehicle']
      // 团体时需录入投保人身份证，所以需添加投保人目录
      if (this.isGroup) {
          types.push('applicant')
      }
      const imageItemInfos = utils.createImageItemInfos(this.quoteInfo, types)
      const data = {
        companyCode: this.quoteInfo.base.companyCode || '',
        imageIds,
        imageItemInfos,
        operator: this.quoteInfo.base.operatorCode || '',
        proposalNo: '',
        step: '投保补传',
      }
      const option = {
        data,
      }
      return $http
        .getImageToken(option)
        .then((res) => {
          if (res.resultCode == '0') {
            return res.result.token
          } else {
            Toast(res.errorMsg || '获取token失败')
          }
        })
        .catch((err) => {
          Toast(err.errorMsg || '获取token失败')
          console.log(err)
        })
    },
    // 初始化SDK
    initUploaderInstance() {
      const vm = this
      const uploaderInstance = new SNKH5Uploader({
        api: {
          base: cloudImageBaseURL,
          // base: 'https://h5file.sinosafe.com.cn/h5img', // 正式
        },
        getToken: function(params) {
          vm.getTokenToImageUpload().then((token) => {
            vm.uploadToken = token
            params.success({
              token,
            })
          })
        },
      })
      uploaderInstance.init({
        success: function() {
          console.log('success')
          // 获取历史影像
          uploaderInstance.queryFiles({
            // imgIdList: [], 为空数组的时候返回改业务号下的所有文件信息
            imgIdList: [],
            success: (res) => {
              // 合并筛选历史影像
              vm.historyImgObj = vm.getCatalogHistoryImg(res)
              console.log('vm.historyImgObj', vm.historyImgObj);
            },
            error: (error) => {
              console.log(error)
            }
          })
        },
        error: function(e) {
          console.log(e)
        },
      })
      vm.uploaderInstance = uploaderInstance
    },
    getCatalogHistoryImg(list) {
      const historyImgObj = {}
      list.forEach((item) => {
        let code = ''
        const pathArr = item.typePath.split('|').filter(Boolean) // 分割后过滤空值，得到路径数组
        const isCheckImg = pathArr.some(p => p.startsWith('S001_0705_')) // 判断是否为验车照片（包含四级路径）
        if (isCheckImg) {
          // 验车照片：typePath是四级（如["S001_07[xxx]","S001_0705","S001_0705_OTH"]），取最后一级（三级code）
          code = pathArr[pathArr.length - 1]
          // 同时存储父级code（S001_0705），用于归类
          const parentCode = 'S001_0705'
          // 给验车照片的obj添加父级code标识，便于后续处理
          item.parentCode = parentCode
        } else {
          // 其他照片：typePath是三级（如["S001_01","S001_0199"]），取最后一级（业务code）
          code = pathArr[pathArr.length - 1]
        }

        // 构建影像对象，存储真实的code和父级code（仅验车照片有）
        const obj = {
          // 影像url
          imgUrl: item.fileRealURL,
          // 影像id
          imgId: item.imgId,
          uploadFlag: 'done',
          isImg: utils.isPostfixImg(item.fileOrgName),
          postFix: utils.getPostFix(item.fileOrgName),
          realCode: code, // 真实业务code（验车是三级code，其他是二级code）
          parentCode: item.parentCode || '' // 验车照片的父级code（S001_0705）
        }

        // 归类：验车照片按父级code（S001_0705）存储，其他按自身code存储
        const targetCode = isCheckImg ? item.parentCode : code
        if (historyImgObj[targetCode]) {
          historyImgObj[targetCode].push(obj)
        } else {
          historyImgObj[targetCode] = [obj]
        }
      })
      return historyImgObj
    },
    getDetail() {
      // 根据地址栏传来的订单号获取订单详情
      $http
        .getOrderDetail({
          params: [this.$route.query.orderNo],
        })
        .then((res) => {
          if (res.resultCode === '0' && res.result) {
            this.quoteInfo = res.result
            // 拿到详情数据后，初始化新影像SDK
            this.initUploaderInstance()
          }
        })
        .catch((err) => {
          Toast(err || '系统异常')
          console.log(err)
        })
    },
  },
  mounted() {
    // 初始化时，获取订单详情
    this.getDetail()
  },
  created() {
    $http
      .officialQueryCheckCode({
        data: {},
      })
      .then((res) => {
        if (res.resultCode == '0') {
          this.checkCode = res.result[0].checkCode
        } else {
          return Promise.reject(res.errorMsg)
        }
      })
      .catch((err) => {
        Toast(err || '系统异常')
      })
  },
}
